import React, { useMemo } from 'react'
import SettingsNavigation from './SettingsAppearance';
import { useTranslation } from 'react-i18next';
import { contractsSettingsSections } from '../../modules/contracts';

const MeunSideSetting = ({ activeMenu, setActiveMenu, group = 'general', onExternalNavigate }) => {
    const [t] = useTranslation('global');
    const [tContracts] = useTranslation('contracts');

    const items = useMemo(() => {
        const general = [
            { id: 'MyAccount', label: t("setting.myAccount") },
            { id: 'GeneralSettings', label: t("setting.generalSettings") },
            { id: 'MyCompany', label: t("setting.companySettings") },
            { id: 'MyBranches', label: t("setting.branchSettings") },
            { id: 'ChangePassword', label: t("setting.changePassword") },
            { id: 'VatSettings', label: t("setting.vatSettings") },
            { id: 'CurrencySettings', label: t("setting.currencySettings") },
            { id: 'LanguagesSetting', label: t("setting.languageSettings") },
            { id: 'ProductServiceSettings', label: t("setting.productServiceSettings") },
        ];

        const sales = [
            { id: 'InvoiceSettings', label: t("setting.invoiceSettings") },
            { id: 'QuoteSettings', label: t("setting.quoteSettings") },
            { id: 'PaymentMethod', label: t("setting.paymentMethodSettings") },
        ];

        const finance = [
            { id: 'Treasury', label: t("setting.financeTreasury") },
            { id: 'account', label: t("setting.financeBankAccounts") },
            { id: 'incomes', label: t("setting.financeReceiptVoucherTypes") },
            { id: 'expenses', label: t("setting.financePaymentVoucherTypes") },
        ];

        const purchases = [
            { id: 'PurchasesInvoiceSettings', label: t("setting.invoiceSettings") },
            { id: 'PurchasesQuoteSettings', label: t("setting.quoteSettings") },
            { id: 'PurchasesPaymentMethod', label: t("setting.paymentMethodSettings") },
        ];

        // Contracts module (src/modules/contracts): its settings sections, labels from its "contracts" namespace.
        const contracts = contractsSettingsSections.map(({ key, labelKey }) => ({ id: key, label: tContracts(labelKey) }));

        if (group === 'sales') return sales;
        if (group === 'finance') return finance;
        if (group === 'purchases') return purchases;
        if (group === 'contracts') return contracts;
        return general;
    }, [group, t, tContracts]);

    const handleClick = (item) => {
        if (item.disabled) return;
        setActiveMenu(item.id);
        if (group === 'finance' && typeof onExternalNavigate === 'function') {
            onExternalNavigate(item.id);
        }
    }

    return <SettingsNavigation items={items} activeMenu={activeMenu} onSelect={handleClick} label={t('setting.System_Settings')} />;
}

export default MeunSideSetting
